import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "../ui/CustomClinikitButton";
import logoIcon from "../../assets/logo-icon.png";
import "./Header.css";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: sectionId } });
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className={`header ${isScrolled ? "header-scrolled" : ""}`}>
      <div className="container header-container">
        <Link to="/" className="main-header-logo">
          <div className="logo-wrapper">
            <span className="logo-text">CliniKit</span>
            <img src={logoIcon} alt="CliniKit" className="logo-icon" />
          </div>
        </Link>

        <nav className={`header-nav ${isMobileMenuOpen ? "nav-open" : ""}`}>
          <ul className="nav-links">
            <li>
              <button
                onClick={() => scrollToSection("hero")}
                className="nav-link"
              >
                ראשי
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection("features")}
                className="nav-link"
              >
                תכונות
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection("pricing")}
                className="nav-link"
              >
                מחירון
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection("faq")}
                className="nav-link"
              >
                שאלות נפוצות
              </button>
            </li>
            <li>
              <Link to="/blog" className="nav-link">
                מאמרים
              </Link>
            </li>
            <li>
              <button
                onClick={() => scrollToSection("contact")}
                className="nav-link"
              >
                צור קשר
              </button>
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          <Link to="/login">
            <Button variant="primary" size="medium">
              התחברות למערכת
            </Button>
          </Link>
        </div>

        <button
          className={`mobile-menu-toggle ${
            isMobileMenuOpen ? "menu-open" : ""
          }`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="תפריט"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
